import StyleHelper from "./styleHelper";

const ARRAY_HELPER = {
    groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    },


    groupBySumWallets(arr) {
        let result = [];
        arr.reduce(function (res, value) {
            if (!res[value.code]) {
                res[value.code] = {code: value.code, name: value?.currency?.name, balance: 0};
                result.push(res[value.code])
            }
            res[value.code].balance += parseFloat(value.balance);
            return res;
        }, {});

        return result
    },
    getColoredData(data) {
        return data?.map(oo => ({
            ...oo,
            color: oo.color === 'random' ? StyleHelper.getRandomColor() : oo.color
        }))
    }
}

export default ARRAY_HELPER
